<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import Module63Item from '../content/Module63Item.vue'

import { getShadowColor } from '@/utils/modules/getStyles'

export default {
  name: 'Comp63',
  components: { ModuleTitle, Module63Item },
  props: {
    moduleOption: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path
    }
  },
  methods: { getShadowColor }
}
</script>

<template>
  <div class="modules-id-63">
    <module-title :title="moduleOption.title" margin-bottom="24" />
    <div class="comp-transverse-2 modules-id-63-content">
      <module63-item
        v-for="(v, i) in moduleOption.list.slice(0, 3)"
        :key="`module63-item-${i}`"
        :memo="v.memo"
        :name="v.name"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modules-id-63-content {
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;
  height: 100%;
}
</style>
